export default __webpack_public_path__ + "static/media/close-icon.e83cb0dc.svg";